import { lazy as reactLazy } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from './constants';

const lazy = {
    ProfilePage: reactLazy(async () => {
        const { ProfilePage } = await import('./Profile');

        return { default: ProfilePage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'navigation.profile',
        page: lazy.ProfilePage,
        path: route.patterns.individualUser.root,
    },
];
